import { CalendarCheckIcon } from "lucide-react";

import {
  FIELD_CONTENT_CLASS,
  FIELD_TRIGGER_CLASS,
  SadieSimulatorField,
} from "./SadieSimulatorField";
import {
  SadieSimulatorJobSearchFields,
  SadieSimulatorJobSearchSetup,
} from "./SadieSimulatorJobSearchFields";
import { SadieSimulatorPipelineEntries } from "./SadieSimulatorPipelineEntries";

import { Column } from "@/components/Column";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@ui/select";

import {
  SadieSimulatorCheckIn,
  SadieSimulatorMatchedOpportunityFit,
  SadieSimulatorMatchedOpportunityOption,
} from "@/types";

export interface SadieSimulatorPostPipelineSetup {
  checkIns: SadieSimulatorCheckIn[];
  onCheckInChange: (key: string) => void;
  selectedCheckIn: string;
}

// Session 4's setup: what Sadie is checking in on, the pipeline the worker
// has at that point, and what a job search finds if they want to look again.
// All of it is fixture data. Nothing is looked up.
export const SadieSimulatorPostPipelineFields = ({
  disabled,
  fitFor,
  jobSearchSetup,
  matchedOpportunities,
  setup,
}: {
  disabled: boolean;
  fitFor: (
    option: SadieSimulatorMatchedOpportunityOption,
  ) => SadieSimulatorMatchedOpportunityFit | undefined;
  jobSearchSetup: SadieSimulatorJobSearchSetup;
  matchedOpportunities: SadieSimulatorMatchedOpportunityOption[];
  setup: SadieSimulatorPostPipelineSetup;
}) => {
  /* Helpers */
  const checkIn = setup.checkIns.find((c) => c.key === setup.selectedCheckIn);

  /* Render */
  return (
    <Column className="gap-3">
      <SadieSimulatorField
        icon={<CalendarCheckIcon />}
        id="sadie-sim-check-in"
        label="Check-in"
      >
        <Select
          disabled={disabled}
          onValueChange={setup.onCheckInChange}
          value={setup.selectedCheckIn}
        >
          <SelectTrigger
            className={FIELD_TRIGGER_CLASS}
            id="sadie-sim-check-in"
          >
            <SelectValue />
          </SelectTrigger>
          <SelectContent className={FIELD_CONTENT_CLASS}>
            {setup.checkIns.map((c) => (
              <SelectItem key={c.key} value={c.key}>
                {c.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        {checkIn ? (
          <SadieSimulatorPipelineEntries
            entries={checkIn.pipeline}
            showSubmitted
          />
        ) : null}
      </SadieSimulatorField>

      <SadieSimulatorJobSearchFields
        alreadySearchedDescription="The search result is in the prompt from the opener"
        disabled={disabled}
        fitFor={fitFor}
        matchedOpportunities={matchedOpportunities}
        setup={jobSearchSetup}
      />
    </Column>
  );
};
